export const NoPageFound = () => {
    return <h1>No Page Found</h1>;
  };